import Index from './index.vue'
// import Create from './components/Create.vue'
import List from './components/List.vue'
// import Edit from './components/Edit.vue'

export default [
  {
    path: 'feedback',
    name: 'feedback',
    component: Index,
    title: 'Feedback',
    redirect: { name: 'feedback-list' },
    children: [
      {
        path: 'list',
        name: 'feedback-list',
        component: List,
      },
    ],
  },
]
